<template>
    <div>
        <div ref="label" class="text-center" />
        <div class="slider-wrapper">
            <div class="slider-control" @click="changeStep(-1)">
                -
            </div>
            <div ref="slider" />
            <div class="slider-control add" @click="changeStep(1)">
                +
            </div>
        </div>
    </div>
</template>

<script>
import noUiSlider from 'nouislider';

const sliderHours = 14;
const maxRange = sliderHours * 60;
const stepRange = 10;

export default {
    name: 'TimeSlider',
    props: {
        value: {
            type: Number,
            required: true
        }
    },
    mounted()
    {
        const startStep = this.value || 0;

        this._sliderInstance = noUiSlider.create(this.$refs.slider, {
            start: [startStep],
            step: stepRange,
            connect: 'lower',
            range: {
                min: 0,
                max: maxRange
            }
        });

        this._sliderInstance.on('update', this.update);
    },
    methods: {
        update(values, handle)
        {
            const value = parseInt(values[handle], 10);
            this.$refs.label.innerHTML = this.getTimeFromSliderValue(value);
            this.$emit('changeValue', value);
        },
        changeStep(direction)
        {
            const currentValue = parseInt(this._sliderInstance.get(), 10);
            this._sliderInstance.set(currentValue + (stepRange * direction));
        },
        getTimeFromSliderValue(value)
        {
            let hours = 0;
            let minutes = 0;

            const tempValue = value / 60;
            hours = Math.floor(tempValue);
            minutes = Math.round((tempValue - hours) * 60);

            if (hours === 0 && minutes === 0)
            {
                return 'h:min';
            }

            hours = (hours < 10) ? `0${hours}` : hours;
            minutes = (minutes === 0) ? `0${minutes}` : minutes;

            return `${hours}:${minutes}`;
        }
    }
};
</script>

<style lang="scss" src="./TimeSlider.scss" />
